import VueI18n from '../plugins/i18n';

export const discountPricesTranslated = Object.freeze({
  NORMAL: { value: 'Normalna', name: VueI18n.t('statics.discountPrice.NORMAL') },
  PALETTE: { value: 'Paleta', name: VueI18n.t('statics.discountPrice.PALETTE') },
  CONTAINER: { value: 'Kontener', name: VueI18n.t('statics.discountPrice.CONTAINER') },
});
